import {DEFAULT_USER_IMAGE} from '../constants/Assets';
import {NO_MUGSHOT} from '../constants/Design';
import {translate} from '../services';
import {CommentObject, mugshotExists} from '../shapes/comments';
import {Locale} from '../shapes/locale';
import {UserType} from '../shapes/user';

import {commentListItem} from './commentReply';
import ImageUrls from './design';
import getTimeElapsedSinceCreation from './getTimeElapsedSinceCreation';
import {isNotUndefined, isUndefined} from './validation';


const getCommentReplies = (imagesHost: string, gardenHost: string, comment: CommentObject, userId: number, locale: Locale,
  userType: UserType, deleteComment: (commentId: number) => void): JSX.Element[] | undefined => {
  const userCommentReplies: JSX.Element[] = [];
  const commentChildren: CommentObject[] | undefined = comment.children;

  function handleDeleteComment(commentId: number) {
    deleteComment(commentId);
  }

  if (isUndefined(commentChildren)) {
    return;
  }

  commentChildren.forEach((childComment: CommentObject) => {
    const childCommentId = childComment.id;
    const userScreenName = childComment.screen_name;
    const mugshot = childComment.mugshot;
    const imageId = mugshotExists(childComment.mugshot) && childComment.mugshot.id;
    const imageFilename = mugshotExists(childComment.mugshot) && childComment.mugshot.filename;
    const mugshotImageUrl = mugshot !== NO_MUGSHOT ?
      ImageUrls.avatarDesignerImageUrl(gardenHost, imageId, imageFilename) : `${imagesHost}/${DEFAULT_USER_IMAGE}`;
    const commentCreatedAt = new Date(childComment.created_at);
    const commentUserId = childComment.user_id;
    const commentParentId = childComment.parent_id;
    const deletedUsersComment = childComment.deleted;
    const usersComment = deletedUsersComment ? translate('designs.comments.deletedComment') : childComment.comment;
    const timeElapsedSinceCreation = getTimeElapsedSinceCreation(locale, commentCreatedAt);
    const userOwnsComment = commentUserId === userId;

    (isNotUndefined(usersComment) && !deletedUsersComment) && userCommentReplies.push(commentListItem(
      childCommentId, mugshotImageUrl, userScreenName, deletedUsersComment, commentCreatedAt, timeElapsedSinceCreation,
      usersComment, userType, userOwnsComment, handleDeleteComment, commentUserId, commentParentId));
  });

  return userCommentReplies.reverse();
};

export default getCommentReplies;
